import {CSSProperties, FC} from 'react';


export interface IIconSpecPriceProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconSpecPrice: FC<IIconSpecPriceProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M18.749 3h-5.304c-.6 0-1.165.234-1.59.659l-8.197 8.197a2.253 2.253 0 0 0 0 3.181l5.303 5.304c.425.425.99.659 1.591.659s1.166-.234 1.591-.66l8.197-8.196c.425-.425.659-.99.659-1.59V5.25c0-1.24-1.01-2.25-2.25-2.25Zm.75 7.553c0 .2-.078.39-.22.53l-8.197 8.197a.768.768 0 0 1-1.06 0l-5.304-5.303a.751.751 0 0 1 0-1.06l8.197-8.197a.746.746 0 0 1 .53-.22h5.304a.75.75 0 0 1 .75.75v5.303ZM17.57 6.33a2.23 2.23 0 0 0-1.603-.704 2.227 2.227 0 0 0-1.622.659 2.238 2.238 0 0 0-.043 3.136l.188.2c.421.445.99.694 1.603.703h.032c.6 0 1.164-.234 1.59-.66a2.237 2.237 0 0 0 .043-3.135l-.188-.2Zm-.916 2.275a.737.737 0 0 1-.54.219.742.742 0 0 1-.534-.234l-.188-.2a.746.746 0 0 1 .014-1.045.743.743 0 0 1 .53-.219h.01a.743.743 0 0 1 .534.234l.189.2a.745.745 0 0 1-.015 1.045ZM9.9 11.24l-.357-.114a.75.75 0 0 1 .455-1.43l.357.114a.75.75 0 0 1-.455 1.43Zm2.306 3.882-.357-.114a.751.751 0 0 0-.455 1.43l.358.114a.75.75 0 0 0 .454-1.43Zm-3.56-1.69 3.768-1.949a.75.75 0 1 1 .69 1.333l-3.769 1.949a.75.75 0 1 1-.69-1.332Z" clipRule="evenodd" />
        </svg>
    );
};
